// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1XloS","emails":"CreateEditClinics_emails__17WzE","emailTagLabel":"CreateEditClinics_emailTagLabel__3Dqxo"};